interface BetweenOptions {
    min: number;
    value: number | string;
    max: number;
    round: number;
    step?: number;
}

export const between = ({ min, value, max, round, step = 0 }: BetweenOptions): number => {
    const parsedValue = typeof value === 'number' ? value : Number.parseInt(value, 10);
    const currentValue = parsedValue + step;

    if (!Number.isSafeInteger(currentValue) || currentValue > max) {
        return max;
    }

    if (currentValue < min) {
        return min;
    }

    return round > 1 ? currentValue - (currentValue % round) : currentValue;
};
